<script setup lang="ts">
import { formatDateRelative } from '@/plugins/i18n';
import type { CommentSummaryDto, FormVoteDto } from '@/services/types/api.types';
import { computed, ref } from 'vue';

import { useFormsStore } from '@/stores';

import CommentSummaryEntry from '@/components/CommentSummaryEntry.vue';
import CommentSummaryEntryAdd from '@/components/CommentSummaryEntryAdd.vue';
import { confirmDelete } from '@/helpers/dialogs.helper';

const formsStore = useFormsStore();

const props = defineProps<{
  votes: FormVoteDto[];
}>();

const columns = ref([
  // { name: 'created_at', label: 'CREATED_AT', align: 'left', field: (row: FormVoteDto) => formatDateRelative(row.created_at) },
  // { name: 'user', label: 'USER', align: 'left', field: (row: FormVoteDto) => `${row.user?.first_name} ${row.user?.last_name}` },
  {
    name: 'value_text',
    label: 'RÉPONSE',
    align: 'left',
    field: (row: FormVoteDto) => row.value_text,
    style: 'max-width: 200px',
  },
  { name: 'summary', label: 'RÉSUMÉ', align: 'left', field: (row: FormVoteDto) => row.summary },
]);

const summaryList = computed(() => {
  const summaryCount: Record<string, number> = props.votes
    .map((item) => (item.summary ? item.summary.map((summary) => summary.text) : []))
    .flat()
    .reduce((acc: Record<string, number>, text) => {
      acc[text] = (acc[text] || 0) + 1;
      return acc;
    }, {});
  return summaryCount;
});

const handleSaveSummaryEntry = async (formVote: FormVoteDto, summaryId: number, text: string) => {
  console.debug('handleSaveSummaryEntry', typeof formVote, formVote, summaryId, text);
  await formsStore.saveVoteSummaryEntry(formVote.form_id, formVote.id, summaryId, text);
};

const handleDeleteSummaryEntry = (formVote: FormVoteDto, summaryId: number) => {
  console.debug('handleDeleteSummaryEntry', formVote, summaryId);
  confirmDelete('ce résumé').onOk(() => {
    formsStore.deleteVoteSummaryEntry(formVote.form_id, formVote.id, summaryId);
  });
};
</script>

<template>
  <q-expansion-item label="Sommaire" class="q-mb-md" dark dense header-class="bg-secondary">
    <q-card>
      <q-card-section>
        <q-list>
          <q-item v-for="(count, text) in summaryList" :key="text" dense>
            <q-item-section>
              <q-item-label>{{ text }} ({{ count }})</q-item-label>
            </q-item-section>
          </q-item>
        </q-list>
      </q-card-section>
    </q-card>
  </q-expansion-item>
  <q-table
    :columns="columns"
    :rows="votes"
    :pagination="{ rowsPerPage: 0 }"
    table-header-class="bg-secondary text-white"
    dense
    wrap-cells
  >
    <template v-slot:body-cell-summary="props">
      <q-td :props="props">
        <div v-for="entry in props.row.summary" :key="entry.id">
          <comment-summary-entry
            :entry="entry"
            @save="(id, text) => handleSaveSummaryEntry(props.row, id, text)"
            @delete="(id) => handleDeleteSummaryEntry(props.row, id)"
          />
        </div>
        <comment-summary-entry-add @save="(id, text) => handleSaveSummaryEntry(props.row, id, text)" />
      </q-td>
    </template>
  </q-table>
</template>
